import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { SHOPIFY_TOKENS } from '../../environments/environment';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {
  
  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const token = sessionStorage.getItem('auth_token');
    let clonedReq = req;

    if (token) {
      clonedReq = req.clone({
        headers: req.headers.set('Authentication', `${token}`)
      });
    }

    return next.handle(clonedReq).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401) {
          console.warn('Session expired. Cleaning token and redirecting to Shopify...');
          
          //remove the expired token immediately
          sessionStorage.removeItem('auth_token');
          localStorage.removeItem('userProfile');
          //redirect the user back to shopify store
          const shopifyAddressesUrl = `https://${SHOPIFY_TOKENS.domain}/apps/sso`;
          window.location.href = shopifyAddressesUrl;
        }
        
        return throwError(() => error);
      })
    );
  }
}
